import type { OccurrenceResponseStatus } from '@kidshome/api-contract';
import { LineIcon } from '@/shared/ui/icons/LineIcon';
import { type LineIconProps } from '@/shared/ui/icons/base';

/**
 * Occurrence-status icons (Register A) — `currentColor` line icons so a {@link StatePill} tints them via its
 * foreground colour (`text-success` / `text-warning` / `text-text-muted`). Shapes stay kind and calm
 * (rejected = a gentle undo loop, never a punitive ✗). The single source for every status pill.
 */
export function StateIcon({
  status,
  rotates = false,
  ...props
}: LineIconProps & {
  status: OccurrenceResponseStatus;
  rotates?: boolean;
}): React.ReactElement {
  if (rotates) {
    return (
      <LineIcon {...props}>
        <path d="M21 12a9 9 0 1 1-3-6.7" />
        <path d="M21 4v5h-5" />
      </LineIcon>
    );
  }
  switch (status) {
    case 'approved':
      return (
        <LineIcon {...props}>
          <path d="M5 13l4 4L19 7" />
        </LineIcon>
      );
    case 'pending_approval':
      return (
        <LineIcon {...props}>
          <circle cx="12" cy="12" r="8.5" />
          <path d="M12 8v4.5l3 2" />
        </LineIcon>
      );
    case 'skipped':
      return (
        <LineIcon {...props}>
          <path d="M6 12h12" />
        </LineIcon>
      );
    case 'missed':
      return (
        <LineIcon {...props}>
          <circle cx="12" cy="12" r="3.2" fill="currentColor" stroke="none" />
        </LineIcon>
      );
    case 'rejected':
      return (
        <LineIcon {...props}>
          <path d="M3 12a9 9 0 1 1 3 6.7" />
          <path d="M3 17v-5h5" />
        </LineIcon>
      );
    case 'planned':
    default:
      return (
        <LineIcon {...props}>
          <circle cx="12" cy="12" r="8" />
        </LineIcon>
      );
  }
}
